// Google Ads conversion reporting. The tag itself is loaded once in the root
// layout; this module is only the typed call site for individual conversions.

// Conversion label for the "Submit lead form" action, issued by Google Ads
// alongside the AW- tag ID. Public by design -- it identifies the conversion,
// it does not authorize anything.
const LEAD_FORM_SEND_TO = 'AW-18415946306/BF2yCI-k0ukcEMKUtM1E';

declare global {
  interface Window {
    gtag?: (
      command: 'event',
      eventName: string,
      params: Record<string, unknown>,
    ) => void;
  }
}

// Google's stock snippet wraps this in a gtag_report_conversion(url) helper that
// navigates on event_callback, because it assumes the conversion fires on a link
// click and the page is about to change. Our contact form never navigates -- it
// POSTs to /api/contact and swaps in an inline success panel -- so there is no
// redirect to defer and no callback to wait for.
//
// Call this only after the API confirms the submission. Firing on click, or on
// a failed request, would report leads we never actually received.
export function reportLeadFormConversion(): void {
  // Absent whenever the tag is blocked by an extension, a privacy-mode browser,
  // or a network failure. A missed conversion is acceptable; a thrown exception
  // that strands a real inquiry mid-submit is not.
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  window.gtag('event', 'conversion', {
    send_to: LEAD_FORM_SEND_TO,
    value: 1.0,
    currency: 'CAD',
  });
}
